/**
 * consists all the api mapping (routes)
 */
export const APIMapping = {
  GET_CHAT_HISTORY:'/chatbot/conversations/:conversation_uuid/history',
  GET_ONGOING_CHAT_CONVERSATIONS: '/chatbot/conversations/ongoing/:csr_uid',
  GET_CHAT_SUMMARY: '/chatbot/conversations/:conversation_uuid/summary',
  UPDATE_CHAT_STATUS: '/chatbot/conversations/:conversation_uuid/update-status/:csr_uid/:csr_status',
  GET_REALM_DETAILS: '/realmDetails/:userName',
  GET_CUSTOMERS_LIST: '/customers',
  GET_APPLICATION_LIST: '/get-applications/:customerId',
  DELETE_APPLICATION: '/delete-application',
  PROMPTS: '/platform/prompt',
  GET_LLM_DROPDOWN_DATA: '/platform/llm_configuration/assigned_and_customer_configs',
  GET_SYSTEM_CUSTOM_PROMPTS: '/platform/prompt/system_custom',

  
  PROMPT_TEMPLATES: '/platform/prompt_template',
  GET_OR_DELETE_PROMPT_BY_ID : '/platform/prompt/:prompt_uuid',
  
  GET_PROMPT_CATEGORY : '/platform/prompt_category',
  DELETE_PROMPT_TEMPLATE: '/platform/prompt_template/:mapping_uuid',
  DELETE_PROMPT : '/platform/prompt/:prompt_uuid',
  GET_DIMENSION_DROPDOWN: '/platform/dimension/get_dimensions_dropdown',
  ADD_CUSTOMER: '/platform/customer/add_customer',
  GET_CUSTOMER_CLIENT_TICKET_LIST: '/platform/ticketing_dashboard/get_tickets',
  GET_CUSTOMER_CLIENT_FILTER_VALUES: '/platform/ticketing_dashboard/get_filters',
  CUSTOMERS: '/platform/customer_client',
  ADD_APPLICATION: '/add-application',
  GET_CHANNELS: '/customer-channels/:customerId',
  UPDATE_APPLICATION: '/edit-application/:id',
  GET_CUSTOMER_COUNTRY_DROPDOWN: '/platform/dimension/geography',
  GET_CUSTOMER_STATE_DROPDOWN: '/platform/dimension/geography/:parent_dimension_uuid',
  DELETE_ORGANIZATION_CUSTOMER: '/platform/customer_client/:customer_client_uuid',
  GET_CUSTOMER_USERS: '/platform/customer_user/client/:customer_client_uuid',
  ORGANIZATION_CUSTOMER_USER: '/platform/customer_user',
  DELETE_ORGANIZATION_CUSTOMER_USER: '/platform/customer_user/:client_user_uuid',
  GET_MERGED_TICKETS_CONVERSATION: '/platform/ticketing_dashboard/get_merged_conversation',
  //email-dashboard
  GET_EMAILS_LIST: '/email/get_email_tickets',
  GET_EMAIL_CONVERSATION: '/email/get_mail_conversation_by_ticket_uuid',
  GET_DOWNLOADABLE_URL: '/email/get_downloadable_urls',
  DRAFT_MAIL: '/email/draft_mail',
  REPLY_EMAIL:'/email/reply_to_mail',
  PURCHASE_ORDER_INFORMATION: '/email/order_details_info',
  GET_EMAIL_CONVERSATION_COUNT: '/email/get_mail_conversation_count_by_ticket_uuid',
  
  //Email Server
  GET_SERVER_PROVIDER : '/platform/server_provider',
  GET_ADD_EDIT_EMAIL_SERVER : '/platform/email_server',
  DELETE_EMAIL_SERVER : '/platform/email_server',
  GET_ADD_EDIT_EMAIL_OUTLOOK : '/platform/outlook_server',

  // User Email Settings Endpoints
  GET_ADD_EDIT_USER_EMAIL_SETTINGS : '/platform/email_settings',
  DELETE_USER_EMAIL_SETTINGS: '/platform/email_settings/:user_email_uuid',
  TEST_CONNECTION_GMAIL: '/platform/email_settings/test_connection/gmail',
  TEST_CONNECTION_OUTLOOK: '/platform/email_settings/test_connection/outlook',
  

  // Dimension Type Endpoints
  DIMENSION_TYPE: '/platform/dimension_type',
  GET_DIMENSION_TYPE_BY_TYPE_UUID: '/platform/dimension_type/:mapping_uuid',

  GET_DIMENSION_TYPE: '/platform/dimension_type',
  EDIT_DIMENSION_TYPE: '/platform/dimension_type/edit_dimension_type',
  ADD_DIMENSION_TYPE: '/platform/dimension_type/add_dimension_type',
  UPDATE_DIMENSION_TYPE_STATUS: '/platform/dimension_type/edit_status', 
  DELETE_DIMENSION_TYPE: '/platform/dimension_type/delete_dimension_type',

  // Dimension Endpoints
  ADD_DIMENSION: '/platform/dimension/add_dimension',
  EDIT_DIMENSION: '/platform/dimension/edit_dimension',
  GET_ALL_DIMENSIONS: '/platform/dimension/get_dimensions',
  

  // Dimension Endpoints
  DIMENSION: '/platform/dimension',
  GET_DIMENSION_BY_TYPE_UUID: '/platform/dimension/type/:dimension_type_uuid',
  DELETE_DIMENSION: '/platform/dimension/:mapping_uuid',

  GENERATE_UTTERANCES: '/email/generate_utterances',
  GET_UTTERANCES_BY_DIMENSION_ID: '/email/utterances',
  DELETE_UTTERANCES_BY_ID: '/email/utterances',
  //  DELETE_DRAFT_MAIL:'/delete_draft_mail/:conversation_uuid',
  GET_STATE_DROPDOWN: '/platform/dimension/states/:country_name',

  //Geography Endpoints
  GET_GEOGRAPHY_COUNTRY_LIST : '/platform/dimension/countries',


  // Customer Tier Endpoints
  GET_CUSTOMERS_BY_TIER: '/platform/customer/get_customers_by_tier',
  CUSTOMER_DROPDOWN_IN_TIER: '/platform/customer/customer_dropdown_in_tier',
  ADD_CUSTOMER_TO_TIER: '/platform/customer/add_customer_tier_application_mapping',
  EDIT_EXTRACTION_TEMPLATE_JSON: '/platform/customer/edit_customer_tier_application_mapping',
  DELETE_CUSTOMER_FROM_TIER: '/platform/customer/delete_customer_tier_application_mapping',
  GET_DIMENSIONS_BY_ID: '/platform/dimension/:mapping_uuid',

   //Chat Configuration
  GET_ALL_OR_UPDATE_CHAT_CONFIGURATIONS:'/platform/chat_configuration',
  GET_OR_DELETE_CHAT_CONFIGURATION: '/platform/chat_configuration/:chat_configuration_uuid',
  GET_ACTIVE_CHAT_CONFIG_OR_UPDATE_CHAT_CONFIG_ACTIVATION_STATUS:'/platform/chat_configuration/activate',

  CREATE_UPDATE_WHATSAPP_GROUP: '/chatbot/phone-groups/',
  GET_WHATSAPP_GROUPS: '/chatbot/phone-groups/',
  UPDATE_GROUP_PHONE_NUMBER: '/chatbot/phone-group-recipients/bulk-add/',
  ADD_WHATSAPP_TEMPLATE: '/chatbot/templates/add-template/',
  UPDATE_WHATSAPP_TEMPLATE: '/chatbot/templates/:template_uuid/update-template/',
  DELETE_WHATSAPP_TEMPLATE: '/chatbot/templates/:template_uuid/',
  GET_WHATSAPP_TEMPLATE: '/chatbot/templates/',
  WHATSAPP_BROADCAST: '/chatbot/broadcast/schedule-broadcast/',

  //Teams Configuration
  UPDATE_TEAMS_CONFIGURATIONS:'/platform/ms-team-configurations',
  GET_TEAMS_CONFIGURATIONS: '/platform/get-ms-team-configurations',
  GET_TEAMS_REDIRECT_URI: '/platform/get_redirect_uri',
   

    // LLM Configuration
  GET_LLM_CONFIGURATION_BY_ID: '/platform/llm_configuration/:llm_configuration_uuid',
  GET_ORGANIZATION_BY_ID: '/platform/assign_organization/:customer_uuid',
  GET_LLM_PROVIDER_METADATA: '/platform/llm_configuration/get_llm_provider_meta_data',
  ASSIGN_ORGANIZATIONS: '/platform/assign_organization',
  DELETE_ASSIGNED_ORGANIZATION: '/platform/assign_organization',
  VERIFY_LLM: '/platform/verify_llm_configuration',
  LLM_CONFIGURATION: '/platform/llm_configuration',
  GET_CUSTOMER_FOR_ORGANIZATION: '/platform/get_customers',
  DELETE_LLM_CONFIGURATION: '/platform/llm_configuration/:llm_configuration_uuid',
  GET_LLM_TOGGLE_STATUS: '/platform/get_llm_status',
  UPDATE_LLM_TOGGLE_STATUS: '/platform/update_llm_status',



  /** ChatBot  */
  ADD_USER_FEEDBACK: '/chatbot/chat_conversation/feedback',
  GET_CHAT_ANALYTICS_DETAILS: '/chatbot/chatbot_analytics/',
  ADD_ATTACHMENT_CHAT_UPLOAD: '/chatbot/upload_attachment',
  GET_CAPTCHA:'/chatbot/captcha/image',
  GET_ALL_INTENTS:'/chatbot/dimension/intents',
  GET_ACTIVE_CHAT_CONFIG:'/platform/chat_configuration/activate',
  GET_PHONENUMBERS_DATA: '/platform/whatsapp_configuration_template/get_business_information',
  GET_PHONE_NUMBER_DETAILS: '/platform/whatsapp_configuration_template/get_whatsapp_business_profile',
  UPDATE_WHATSAPP_CHAT_CONFIGURATION: '/platform/chat_configuration_template/update_chat_configuration',


 /**
   * Knowledge Base File Related Api's
  */  
  GET_FILE_ERRORS: '/chatbot/knowledge-sources/errors',
  GET_ALL_FILES: '/chatbot/knowledge-sources',
  GET_FILE_VERSION_LIST: '/chatbot/knowledge-sources/versions',
  DELETE_FILE: '/chatbot/knowledge-sources/:knowledge_source_uuid',
  CANCEL_FILE:'/chatbot/knowledge-sources/:knowledge_source_uuid/cancel',


  GET_TABLE_ERRORS:'/chatbot/errors/tables/:file_uuid/:table_id',
  UPDATE_TABLE_ERRORS:'/chatbot/errors/tables',

  GET_VIDEO_TRANSCRIPTION_ERRORS:'/chatbot/errors/videos/:file_uuid',
  UPDATE_VIDEO_TRANSCRIPTION_ERRORS:'/chatbot/errors/videos',

  GET_FILE_PROCUCTS:'/chatbot/files/get_file_product/:file_uuid',
  ASSIGN_PRODUCT:'/chatbot/files/assign_product',

  GET_MAIN_HEADINGS:'/chatbot/errors/headers/:file_uuid/main',
  GET_SUB_HEADINGS:'/chatbot/errors/headers/:file_uuid/sub/:block_id',
  ADD_HEADING:'/chatbot/errors/headers',

   /**Error Resolve */
  GET_PAGE_BLOCKS: '/chatbot/errors/pages/:file_uuid/:page',
  RESOLVE_PAGE_ERROR: '/chatbot/errors/pages',


/**
   *  Knowledge Base Product Related Api's
  */  
  ENTITY: '/chatbot/entity',
  GET_PRODUCT_DATA_BY_ID: '/chatbot/entity/:entity_uuid',
  DELETE_PRODUCT: '/chatbot/entity/:entity_uuid',
  GET_MAPPED_FILE: '/chatbot/knowledgesources/:entity_uuid',
  ENTITY_STATUS: '/chatbot/entities/knowledge-source',
    
  /** CW-Chat */
  CREATE_SESSION:'/chat/get_session/:dashboard_id',
  FETCHING_CHATBOT_HISTORY:'/chat/get_conversation/:session_id',
  CHAT_QUERY:'/chat/query',
  GET_VIDEOS_IN_APPLICATION: '/chatbot/knowledge-sources/videos',
  
  CHECK_KNOWLEDGE_SOURCES_EXISTS: '/chatbot/knowledge-sources/exists',
  UPLOAD_FILES_VIA_DRIVES: '/chatbot/knowledge-sources/drives-files',
  UPLOAD_KNOWLEDGE_SOURCES: '/chatbot/knowledge-sources',
  REUPLOAD_KNOWLEDGE_SOURCE: '/chatbot/knowledge-sources/reupload',
  REPROCESS_KNOWLEDGE_SOURCE:'/chatbot/knowledge-sources/:knowledge_source_uuid',

  /** SME Dashboard */
  QUESTION: '/chatbot/sme/question',
  GET_FILES_FOR_QA: '/chatbot/knowledge-sources/questions-answers',
  GET_GENERATED_QUESTION: '/chatbot/sme/generate_qa',
  UPDATE_ANSWER: '/chatbot/sme/answer',
  DELETE_QUESTION: '/chatbot/sme/question/:question_uuid',
  GENERATE_IMAGE_SRC: '/chatbot/knowledge-sources/image-url',
  GET_QUESTION_DETAILS: '/chatbot/sme/question/:question_uuid',
  FEEDBACK: '/chatbot/sme/feedback',
  VERIFY_ANSWER: '/chatbot/sme/verify',
  GET_QA_GENERATED_FILES: '/chatbot/knowledge-sources/qa_generated_knowledge_sources',
  DELETE_FILE_QA: '/chatbot/knowledge-sources/delete_qa/:knowledge_source_name',
  GET_QUESTION_AUDIT_HISTORY: '/chatbot/sme/answer/history',

  /** File review */
  UPDATE_FILE_REVIEW_JSON:'/chatbot/knowledge-sources/internal_json/edit',
  GET_PAGE_JSON_DATA: '/chatbot/knowledge-sources/internal_json/:knowledge_source_uuid/:page_number',
  UPDATE_PAGE_JSON_DATA: '/chatbot/knowledge-sources/internal_json',
  GET_FILE_REVIEW_JSON: '/chatbot/knowledge-sources/internal_json/:knowledge_source_uuid',
  GET_FILE:'/chatbot/knowledge-sources/:knowledge_source_uuid',
  FILE_RESOLVE_BY_REVIEW: '/chatbot/knowledge-sources/:knowledge_source_uuid/resolve',

  RESET_PASSWORD: '/reset-user-password',

  GET_DEPARTMENT_DATA: '/chatbot/departments/',
  GET_AGENTS_DATA: '/chatbot/agents/',

  /**Response Customization */
  FETCH_DIMENSIONS : '/email/fetch_intents_subintents_sentiment',
  SAVE_RESPONSE_CONFIG: '/email/save_response_configurations',
  DELETE_RESPONSE_CONFIG: '/email/delete_emails_responses',
  FETCH_RESPONSE_CONFIG: '/email/fetch_response_configurations',


  //REFACTORED APIS
  CUSTOMER_CLIENT_TIER_MAPPING: '/platform/customer_client_tier_mapping',
  GET_CUSTOMER_CLIENT: '/platform/customer_tier_mapping/:tierMappingUuid',
  DELETE_CUSTOMER_CLIENT_TIER_MAPPING: '/platform/customer_client_tier_mapping/:mapping_uuid',
  GET_CUSTOMER_CLIENT_TIER_DROPDOWN: '/platform/customer_client_tier_dropdown',
  RESPONSE_CONFIG: '/email/response_configurations',
  DOWNLOAD_SAMPLE_RESPONSE_CONFIG: '/email/download_responses_template',

  GET_CONTENT_URL: '/email/get_content_from_url',

  DOWNLOAD_INTENT_TRAINING_PHRASES: '/email/intents_with_training_phrases',


  // MFA APIs
  GET_MFA_DETAILS : '/auth/realms/:realm_name/mfa/:user_id/mfa-details',
  GENERATE_TOTP_QR : '/auth/realms/:realm_name/mfa/:user_id/generate-totp-qr',
  VALIDATE_OTP : '/auth/realms/:realm_name/mfa/:user_id/validate-totp',
  DELETE_CREDENTIALS : '/auth/realms/:realm_name/mfa/:user_id/delete-totp/:credentialId',
  TOOGLE_MFA : '/auth/realms/:realm_name/mfa/:user_id/toggle-mfa',
  TOGGLE_MFA_BULK_USER: '/auth/realms/:realm_name/mfa/toggle-mfa',

  USERS_MFA_DETAILS: '/users/mfa-details',
  USER_MFA_DETAILS: '/users/mfa-details/:id',
  UPDATE_USERS_MFA_DETAILS: '/update-mfa',  

// GET_PAGES: 'pages/:application_id',
// CREATE_OR_UPDATE_PAGE : 'pages',

  //User activity tracking APIs

  USER_DETAILS: '/chatbot/useractivity/userinfo',
  TIME_SERIES: '/chatbot/useractivity/timeseries',
  AVERAGE_STATS: '/chatbot/useractivity/averagestats',
  LEADER_BOARD: '/chatbot/useractivity/leaderboard',
  THUMBS_DOWN: '/chatbot/useractivity/feedback',
  CHAT_HISTORY_LIST: '/chatbot/useractivity/conversations',


  // Compliance APIs
  VALIDATE_COMPLIANCE : '/clause/validate_docs/',
  REVALIDATE_CLAUSE : '/clause/revalidate_clause/',
  PERFORM_REPORT_ACTION : '/compliance/reports',
  GET_REPORT_DATA : '/compliance/reports/data',
  GET_CLAUSE_REQUIREMENT_DATA : '/compliance/clause-requirement',
  COMPARE_REPORT : '/compliance/reports/compare',
  DOWNLOAD_REPORT : '/compliance/reports/download',
  UPDATE_REQUIREMENT : '/compliance/requirements',
  DELETE_REQUIREMENT : '/compliance/requirements',

  // ticketing dashboad
  GET_TICKET_DROPDOWN : '/platform/ticketing_dashboard/get_ticket_dropdown',
  MERGE_TICKETS : '/platform/ticketing_dashboard/merge_tickets',
  SOCIAL_LOGIN: '/social-login',

  GET_TICKET_HISTORY: '/chatbot/conversations/:ticket_uuid/chat_history',
  GET_TICKET_SUMMARY: '/chatbot/conversations/:ticket_uuid/chat_summary',
  MARK_EMAIL_AS_READ: '/platform/ticketing_dashboard/mark_email_as_read',

  ADD_TRAINING_PHRASES: '/platform/add_training_phrases',
  EDIT_TRAINING_PHRASES: '/platform/edit_training_phrase',
  DOWNLOAD_TRAINING_PHRASES: '/platform/download_training_phrases',
  UPLOAD_BULK_IMPORT: '/platform/upload_examples_to_chromadb',
  RESOLVE_UPLOAD_BULK_IMPORT: '/platform/resolve_duplicates',
  DOWNLOAD_SAMPLE_INTENT_FILE: '/platform/download_template',

  //WiseFlow Entities API's
  GET_ENTITIES_LIST: '/wiseflow/entity/get_entities',
  DELETE_CUSTOM_ENTITIES: '/wiseflow/entity/:entity_uuid',
  CUSTOM_ENTITIES: '/wiseflow/entity',
  GET_PARENT_ENTITIES: '/wiseflow/parent_entities',

  //Wise flow -> flow API's
  WISEFLOW_LIST: '/wiseflow/get_wiseflows',
  WISEFLOW_VARIABLES: '/wiseflow/variables/:wiseflow_uuid',
  SAVE_OR_EDIT_FLOW: '/wiseflow/wiseflow',
  DELETE_UPDATE_GET_FLOW:'/wiseflow/wiseflow/:wiseflow_uuid',
  WISEFLOW_INTENT_SUBINTENT: '/wiseflow/fetch_intents_subintents',
  GET_WISEFLOW: '/wiseflow/wiseflow/:wiseflow_uuid ',
  DELETE_SPECIAL_INSTRUCTION: '/wiseflow/delete_instruction_utterances',
  FETCH_ENTITY_CONFIGURATION: '/wiseflow/get_entities_configuration',
  FETCH_INSTRUCTION_OR_EXAMPLE: '/wiseflow/fetch_utterances',
  FETCH_METADATA: '/wiseflow/get_available_metadata',
  FETCH_END_CONV_HANDLER_METADATA: '/wiseflow/get_default_handler_data',
  WISEFLOW_NAME_CHECK: '/wiseflow/check',
  WISEFLOW_KNOWLEDGE_SOURCE: '/chatbot/knowledge-sources/get_files_by_statuses_and_types',

  //wise flow -> tools API's
  AVAILABLE_TOOL_TYPES: '/wiseflow/tool_types',
  TOOL_COLLECTION: '/wiseflow/tool_collection',
  GET_OR_DELETE_TOOL_COLLECTIONS_BY_TYPE_ID: '/wiseflow/tool_collection/:mapping_uuid',

  TOOL: '/wiseflow/tool',
  TOOL_BY_ID: '/wiseflow/tool/:mapping_uuid',
  GET_TOOLS_LIST: '/wiseflow/tool/list',
  GET_SENTIMENT_HANDLER: '/wiseflow/event_handlers/dimensions/SENTIMENT',

  //wiseflow-customer-tier-handler API
  GET_CUSTOMER_TIER_DETAILS: '/wiseflow/event_handlers/dimensions/CUSTOMER_TIER',
  GET_GEOGRAPHY_HANDLER_DETAILS: '/wiseflow/event_handlers/dimensions/GEOGRAPHY',

  //configure email for processing
  CUSTOMER_CLIENTS_LIST: '/platform/email_processing_config/client_and_user_emails',
  EMAIL_PROCESSING_CONFIG: '/platform/email_processing_config',

  VALIDATE_EXCEL: '/wiseflow/validate_excel',

  //Nudge API's
  GET_ALL_EVENTS: '/wiseflow/event',
  UPDATE_EVENT_STATUS:'/wiseflow/event/status',
  GET_EVENT_DETAILS: '/wiseflow/event/:mapping_uuid',
  SAVE_EVENT_DETAILS:'/wiseflow/event/configuration',


  //Document Parsing step-Wisefloe
  GET_EXECUTION_DETAILS: '/wiseflow/step-type-execution-details',
  GET_LLMCONFIG_DETAILS: '/wiseflow/check_llm_config',
}
